import { render, staticRenderFns } from "./BarchartPage.vue?vue&type=template&id=090a6c8a&scoped=true&"
import script from "./BarchartPage.vue?vue&type=script&lang=js&"
export * from "./BarchartPage.vue?vue&type=script&lang=js&"
import style0 from "./BarchartPage.vue?vue&type=style&index=0&id=090a6c8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090a6c8a",
  null
  
)

export default component.exports